__turbopack_context__.v({
  "section-teaser": "TR6u1G_section-teaser",
  "section-teaser__animation": "TR6u1G_section-teaser__animation",
  "section-teaser__box-wrapper": "TR6u1G_section-teaser__box-wrapper",
  "section-teaser__text": "TR6u1G_section-teaser__text",
  "section-teaser__title": "TR6u1G_section-teaser__title",
});
